/**
 * System entropy only. Math.random is never used anywhere in this engine:
 * it is seeded and predictable, and has no business picking a lottery grid.
 */

function getCrypto(): Crypto {
  // Read through a cast rather than globalThis.crypto: the engine also compiles
  // against the Workers runtime types, where crypto is not on typeof globalThis.
  const c = (globalThis as { crypto?: Crypto }).crypto;
  if (c === undefined || typeof c.getRandomValues !== 'function') {
    throw new Error(
      'crypto.getRandomValues indisponible : contexte non securise (https ou localhost requis).',
    );
  }
  return c;
}

/** Uniform float in [0, 1) with a full 53 bits of entropy. */
export function randomUnit(): number {
  const buf = new Uint32Array(2);
  getCrypto().getRandomValues(buf);
  const hi = (buf[0] as number) >>> 5; // 27 bits
  const lo = (buf[1] as number) >>> 6; // 26 bits
  return (hi * 67108864 + lo) / 9007199254740992;
}
